"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TimeUnit = exports.Order = void 0;
var TimeUnit = exports.TimeUnit = function (a) {
    return a.Minute = "MINUTE", a.Hour = "HOUR", a.Day = "DAY", a.Week = "WEEK", a.Month = "MONTH", a;
  }({}),
  Order = exports.Order = function (a) {
    return a.Ascending = "asc", a.Descending = "desc", a;
  }({});